import { render, staticRenderFns } from "./PwChange.vue?vue&type=template&id=ed65354a&scoped=true&"
import script from "./PwChange.vue?vue&type=script&lang=js&"
export * from "./PwChange.vue?vue&type=script&lang=js&"
import style0 from "./PwChange.vue?vue&type=style&index=0&id=ed65354a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed65354a",
  null
  
)

export default component.exports